import Lottie from 'lottie-react';
import styled from '@emotion/styled';
import { MDSIcon } from '@marqvision/mds-v2';
import magicIconAnimation from './magicIconAnimation.json';

const Styled = {
  Icon: styled.svg`
    & path {
      fill: url(#gradient) !important; // @morgan: MDSChip 내부에 넣으면 fill 이 닦여버려서 important 추가함
    }
  `,
  GradientStart: styled.stop`
    stop-color: ${({ theme }) => theme._raw_color.blue400};
  `,
  GradientEnd: styled.stop`
    stop-color: ${({ theme }) => theme._raw_color.purple500};
  `,
};

type Props = {
  animate?: boolean;
  size?: number;
};

export const StarIcon = (props: Props) => {
  const { animate, size = 20 } = props;

  return animate ? (
    <Lottie animationData={magicIconAnimation} style={{ width: size, height: size, display: 'flex' }} />
  ) : (
    <Styled.Icon
      width={size}
      height={size}
      style={{ width: `${size}px`, height: `${size}px`, flex: `0 0 ${size}px` }}
    >
      <defs>
        <linearGradient
          id="gradient"
          x1="9.99992"
          y1="0.833252"
          x2="9.99992"
          y2="19.1666"
          gradientUnits="userSpaceOnUse"
        >
          <Styled.GradientStart offset="0.415" />
          <Styled.GradientEnd offset="1" />
        </linearGradient>
      </defs>
      <MDSIcon.Magic size={size} />
    </Styled.Icon>
  );
};
